<template>
  <div v-if="items && items.length > 0" :style="`border-bottom: ${filterBorderBottomColor} 1px solid;`" class="filters-container mb-0 pb-0">
    <div class="storefront-sidebar-filters-title" @click="collapse">
      <h6 class="row m-0 align-items-center mb-0">
        <div style="width: 32px">
          <SidebarCategoryIcon
            v-if="icon == 'category'"
            class=""
            :fill="iconColor"
            :svg-style="{
              top: '-1px',
              position: 'relative',
              height: '20px',
              width: '20px',
            }"
          />
          <FeaturedIcon v-else-if="icon == 'star'" class="" type="outline" :fill="iconColor" style="width: 1rem; height: 1rem" />
          <SidebarStrainIcon
            v-else-if="icon == 'strain'"
            class=""
            :fill="iconColor"
            :svg-style="{
              top: '-1px',
              position: 'relative',
              height: '20px',
              width: '20px',
            }"
          />
          <SidebarProductTypeIcon
            v-else-if="icon == 'product-type'"
            class=""
            :fill="iconColor"
            :svg-style="{
              top: '-1px',
              position: 'relative',
              height: '20px',
              width: '20px',
            }"
          />
          <SidebarCannaIcon
            v-else-if="icon == 'canna'"
            class=""
            :fill="iconColor"
            :svg-style="{
              top: '-1px',
              position: 'relative',
              height: '20px',
              width: '20px',
            }"
          />
          <SidebarBrandIcon
            v-else-if="icon == 'brand'"
            class=""
            :fill="iconColor"
            :svg-style="{
              top: '-1px',
              position: 'relative',
              height: '20px',
              width: '20px',
            }"
          />
          <SidebarMedRecIcon
            v-else-if="icon == 'med/rec'"
            class=""
            :fill="iconColor"
            :svg-style="{
              top: '-1px',
              position: 'relative',
              height: '20px',
              width: '20px',
            }"
          />
        </div>

        <span :style="`color: ${titleColor}`">
          {{ title }}
        </span>
        <i :style="`color: ${titleColor}`" :class="`fa fas fa-angle-${collapsed ? 'up' : 'down'} ml-auto`" />
      </h6>
    </div>
    <b-collapse class="storefront-sidebar-filters" :visible="!collapsed">
      <ul v-if="sortedItems" class="nav flex-column">
        <li v-for="(item, i) in sortedItems" :key="i" :style="filterItemStyle(item)" class="nav-item user-select-none">
          <SelectBox
            :label="item.label"
            :selected="item.selected"
            :selected-color="selectedCheckboxColor"
            :not-selected-color="unSelectedCheckboxColor"
            @on-selected="onSelected(item)"
          />
        </li>
      </ul>
      <slot />
    </b-collapse>
  </div>
</template>
<script>
import clonedeep from "lodash.clonedeep";
import SidebarCategoryIcon from "@/components/common/icons/SidebarCategoryIcon.vue";
import SidebarStrainIcon from "@/components/common/icons/SidebarStrainIcon.vue";
import SidebarProductTypeIcon from "@/components/common/icons/SidebarProductTypeIcon.vue";
import SidebarCannaIcon from "@/components/common/icons/SidebarCannaIcon.vue";
import SidebarBrandIcon from "@/components/common/icons/SidebarBrandIcon.vue";
import FeaturedIcon from "@/components/common/icons/FeaturedIcon.vue";
import SidebarMedRecIcon from "@/components/common/icons/SidebarMedRecIcon.vue";
import SelectBox from "@/components/common/SelectBox.vue";
import BCollapse from "@/components/base/BCollapse.vue";

export default {
  components: {
    SidebarCategoryIcon,
    SidebarStrainIcon,
    SelectBox,
    SidebarProductTypeIcon,
    SidebarCannaIcon,
    SidebarBrandIcon,
    SidebarMedRecIcon,
    FeaturedIcon,
    BCollapse,
  },
  props: {
    title: { type: String, required: true },
    icon: { type: String },
    iconColor: { type: String },
    titleColor: { type: String },
    selectedCheckboxColor: { type: String },
    unSelectedCheckboxColor: { type: String },
    filterBorderBottomColor: { type: String },
    itemTextColor: { type: String },
    selectedTextColor: { type: String },
    items: { type: Array, required: true },
    multiSelect: { type: Boolean, default: false },
    initCollapsed: { type: Boolean, default: true },
    sortingAlg: { type: String },
  },
  emits: ["selected"],
  data() {
    return {
      collapsed: this.initCollapsed,
      sortedItems: undefined,
    };
  },
  computed: {
    cssVars() {
      return {
        "--bg-color": this.selectedTextColor,
      };
    },
  },
  watch: {
    items(newItems) {
      this.sortItems(newItems);
    },
  },
  mounted() {
    if (this.items && !this.sortedItems) {
      this.sortItems(this.items);
    }
  },
  methods: {
    filterItemStyle(item) {
      if (item.selected) {
        return {
          color: this.selectedTextColor,
        };
      }
      return {
        color: this.itemTextColor,
      };
    },
    collapse() {
      this.collapsed = !this.collapsed;
    },
    onSelected(item) {
      this.$emit("selected", item);
    },
    sortItems(items, sortingAlg = this.sortingAlg) {
      const tempItems = clonedeep(items);
      tempItems.sort((a, b) => {
        switch (sortingAlg) {
          default:
            return this.alphabeticalSort(a.label, b.label);
        }
      });
      this.sortedItems = tempItems;
    },
    alphabeticalSort(a, b) {
      if (a < b) return -1;
      if (a > b) return 1;
      return 0;
    },
  },
};
</script>
<style></style>
